import * as React from 'react'
import { observer } from 'mobx-react'
import ProfileViewModel from '../../ProfileViewModel'
import SectionEmpty from '../../SectionEmpty'
import SelectionList from '../../SelectionList'
import Icon from 'components/Icon'
import SelectionEditorDialog from '../../SelectionEditorDialog'

interface RolesProps {
  vm: ProfileViewModel
}

export default observer(function Roles({ vm }: RolesProps) {
  const createList = (editing: boolean) => (
    <SelectionList
      selectionVM={vm.general.roleSelection}
      editing={editing}
      icon={<Icon name="roles" />}
      getContent={(item) => ({
        title: item.name,
        description: item.description,
      })}
    />
  )
  return (
    <>
      {vm.general.roleSelection.selectedItems.length === 0 ? (
        <SectionEmpty>You don't have any specific roles.</SectionEmpty>
      ) : (
        createList(false)
      )}
      <SelectionEditorDialog
        title="Manage User Roles"
        description={
          <>
            Select the roles to assign to{' '}
            <strong>{vm.member.displayName}</strong>
          </>
        }
        selectionVM={vm.general.roleSelection}
      >
        {createList(true)}
      </SelectionEditorDialog>
    </>
  )
})
